import { FaAppStoreIos, FaGlobeAmericas } from "react-icons/fa";
import { CgIfDesign } from "react-icons/cg";
import { AiFillSecurityScan } from "react-icons/ai";
import { SiXdadevelopers, SiAntdesign } from "react-icons/si";
import {
  cyberBlogImg,
  nextBlogImg,
  noorShopImg,
  educareImg,
  amazonCloneImg,
  petroliImg,
  saharaImg,
  hseDesignImg,
  midasDemo,
  resumeTest,
  resumeTest2,
  dashboard,
  modernPayment,
  dynamicPortfolio,
  reactBD,
  orebiShopping,
} from "../assets";

// ======================= Skill List Start here ==========================
export const SkillsList = [
  {
    id: 1001,
    title: "Javascript",
    link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    id: 1002,
    title: "React js",
    link: "https://reactjs.org/",
  },
  {
    id: 1003,
    title: "Next js",
    link: "https://nextjs.org/",
  },
  {
    id: 1004,
    title: "Node js",
    link: "https://nodejs.org/en/",
  },
  {
    id: 1005,
    title: "Typescript",
    link: "https://www.typescriptlang.org/",
  },
  {
    id: 1006,
    title: "Express js",
    link: "https://expressjs.com/",
  },
  {
    id: 1007,
    title: "Redux Toolkit",
    link: "https://redux-toolkit.js.org/",
  },
  {
    id: 1008,
    title: "MongoDB",
    link: "https://www.mongodb.com/",
  },
  {
    id: 1009,
    title: "Google Firebase",
    link: "https://firebase.google.com/",
  },
  {
    id: 1010,
    title: "Tailwindcss",
    link: "https://tailwindcss.com/",
  },
  {
    id: 1011,
    title: "Sanity.io",
    link: "https://www.sanity.io/",
  },
  {
    id: 1012,
    title: "HTML5",
    link: "https://developer.mozilla.org/en-US/docs/Glossary/HTML5",
  },
  {
    id: 10100,
    title: "CSS3",
    link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    id: 1013,
    title: "VS Code",
    link: "https://code.visualstudio.com/",
  },
  {
    id: 1014,
    title: "Atom",
    link: "https://atom.io/",
  },
  {
    id: 1015,
    title: "Git",
    link: "https://git-scm.com/",
  },
  {
    id: 1016,
    title: "Github",
    link: "https://github.com/",
  },
  {
    id: 1017,
    title: "Trello",
    link: "https://trello.com/en",
  },
  {
    id: 1018,
    title: "GitKraken",
    link: "https://www.gitkraken.com/",
  },
  {
    id: 1019,
    title: "UI Design",
    link: "https://www.behance.net/",
  },
  {
    id: 1020,
    title: "Figma",
    link: "https://www.figma.com/",
  },
  {
    id: 1021,
    title: "Canva",
    link: "https://www.canva.com/",
  },
  {
    id: 1022,
    title: "Adobe Illustrator",
    link: "https://www.adobe.com/products/illustrator/free-trial-download.html",
  },
  {
    id: 1023,
    title: "Brand & Logo Design",
    link: "https://dribbble.com/",
  },
  {
    id: 1024,
    title: "Web Site Design",
    link: "https://themeforest.net/",
  },
  {
    id: 1025,
    title: "Vercel",
    link: "https://vercel.com/",
  },
  {
    id: 1026,
    title: "netlify",
    link: "https://www.netlify.com/",
  },
];
// ======================= Skill List End here ============================
// ======================= TopProjectList Start here ======================
export const TopProjectList = [
  {
    id: 3001,
    image: cyberBlogImg,
    title: "Cyber Security Blog",
    link: "https://www.noormohmmad.com/",
  },
  {
    id: 3006,
    image: reactBD,
    title: "React BD Company",
    link: "https://reactbd.com/",
  },
  {
    id: 3005,
    image: amazonCloneImg,
    title: "Amazon Clone",
    link: "https://amazonclone.reactbd.com/",
  },
  {
    id: 3002,
    image: orebiShopping,
    title: "OREBI Shopping",
    link: "https://orebishopping.reactbd.com/",
  },
  {
    id: 3003,
    image: educareImg,
    title: "Educare English Leaning Academy",
    link: "https://www.educareenglishlearningacademy.com/",
  },
  {
    id: 3004,
    image: dynamicPortfolio,
    title: "Dynamic Portfolio",
    link: "https://portfolioone.reactbd.com/",
  },
];
// ======================= TopProjectList End here ========================
// ======================= All Project List Start here ====================
export const ProjectList = [
  {
    id: 2001,
    image: cyberBlogImg,
    title: "Cyber Security Blog",
    link: "https://www.noormohmmad.com/",
  },
  {
    id: 5002,
    image: reactBD,
    title: "React BD Company",
    link: "https://reactbd.com/",
  },
  {
    id: 3050,
    image: amazonCloneImg,
    title: "Amazon Clone",
    link: "https://amazonclone.reactbd.com/",
  },
  {
    id: 3051,
    image: orebiShopping,
    title: "OREBI Shopping",
    link: "https://orebishopping.reactbd.com/",
  },
  {
    id: 3002,
    image: noorShopImg,
    title: "Noor Online Shopping",
    link: "https://noorshop.netlify.app/",
  },
  {
    id: 3003,
    image: educareImg,
    title: "Educare English Leaning Academy",
    link: "https://www.educareenglishlearningacademy.com/",
  },
  {
    id: 5001,
    image: dynamicPortfolio,
    title: "Dynamic Portfolio",
    link: "https://portfolioone.reactbd.com/",
  },
  {
    id: 2003,
    image: nextBlogImg,
    title: "React Blog",
    link: "https://my-blog-delta-eight.vercel.app/",
  },
  {
    id: 2004,
    image: saharaImg,
    title: "Sahara Hospitality Demo",
    link: "https://unknown2832021.github.io/Sahara_New_Beginning/",
  },
  {
    id: 2005,
    image: petroliImg,
    title: "Petroli oil company",
    link: "https://petriol.vercel.app/",
  },
  {
    id: 2006,
    image: hseDesignImg,
    title: "HSE Management",
    link: "https://aaoman.vercel.app/",
  },
  {
    id: 2007,
    image: midasDemo,
    title: "Midas TMI demo",
    link: "https://midastmi.vercel.app/",
  },
  {
    id: 2008,
    image: resumeTest,
    title: "Modern Resume",
    link: "https://noormohmmad.com/",
  },
  {
    id: 2009,
    image: dashboard,
    title: "Dashboard Management",
    link: "https://profile-ochre-pi.vercel.app/",
  },
  {
    id: 2010,
    image: modernPayment,
    title: "Modern Payment Website",
    link: "https://modernpayment.vercel.app/",
  },
  {
    id: 2011,
    image: resumeTest2,
    title: "Test Resume",
    link: "https://portfolio-3-nextjs.vercel.app/",
  },
];
// ======================= All Project List End here ======================

// ======================== Services Info Start here ======================
export const ServicesInfo = [
  {
    _id: "1001",
    icon: <SiXdadevelopers />,
    title: "Web Development",
    des: "From design to integration to maintenance, I offer full-cycle web application development services besides being Able to build apps that are secure, scalable, fast, and work well across all devices and platforms.",
    imgSrc: cyberBlogImg,
    website: "https://blog.reactbd.com/",
    servicesDes:
      "Your website is the foundation of your digital presence, it's usually the first point of contact someone has with your brand, it's your office, your reception, your checkout and so on. The impression your website gives off is what people take away with them. A well-established site tells your leads that your business is trustworthy and professional before you even begin speaking or interacting with them.",
    servicesOffer:
      "I am offering to make your website and developed it in the way you desired.",
    servicesIncluded: [
      {
        _id: 101,
        title: "Responsive Website",
      },
      {
        _id: 102,
        title: "Clean Coding",
      },
      {
        _id: 103,
        title: "Deployment",
      },
      {
        _id: 104,
        title: "Maintenence",
      },
    ],
    servicesCategories: [
      {
        _id: 201,
        title: "E-commerce websites",
      },
      {
        _id: 202,
        title: "Chatting Application",
      },
      {
        _id: 203,
        title: "Portfolio",
      },
      {
        _id: 204,
        title: "Business & Promotion",
      },
    ],
  },
  {
    _id: "1002",
    icon: <FaAppStoreIos />,
    title: "Mobile Application",
    des: "I am developing modern designs, top-notch quality code, and features-rich applications at affordable cost across multiple terrains including iOS, Android, Hybrid, Cross-platform.",
    imgSrc: noorShopImg,
    website: "https://bazar.reactbd.com/",
    servicesOffer:
      "I am offering to make your mobile application as smooth as it can be.",
    servicesDes:
      "To create a fast and smooth app for any platform, I deliver products with an outsourcing app development model. This model gives a reasonable solution to control the budget and other recourses. I am connecting conventional essential technologies and architecture with the unique logic of the app. Combined with a polished design and UI an app becomes the one that reaches the goals perfectly. Whether you are looking to create a mobile application for smartphones, tablets, or both, I can be your guy covered no matter the platform it is to be built on or device it is to be used in conjunction with.",
    servicesIncluded: [
      {
        _id: 101,
        title: "Responsive Design",
      },
      {
        _id: 102,
        title: "Coding",
      },
      {
        _id: 103,
        title: "Hostings",
      },
      {
        _id: 104,
        title: "SEO Optimization",
      },
    ],
    servicesCategories: [
      {
        _id: 201,
        title: "Native Mobile Applications",
      },
      {
        _id: 202,
        title: "iOS App Development",
      },
      {
        _id: 203,
        title: "Andriod App Development",
      },
      {
        _id: 204,
        title: "Cross Platform App Development",
      },
      {
        _id: 205,
        title: "Real Device Testing",
      },
    ],
  },
  {
    _id: "1003",
    icon: <AiFillSecurityScan />,
    title: "Cyber Security",
    des: "When security incidents occur, you've got to have an effective response. The speed with which your company recognizes analyzes, and responds to an incident makes all the difference.",
    imgSrc: cyberBlogImg,
    website: "https://blog.reactbd.com/",
    servicesDes:
      "Cyber Security is a set of techniques that are used to protect internet-connected systems. It can protect computers, networks, software, and data. Cyber-attacks are performed to make unauthorized access, change or destroy data, or extort money. Ransomware, Malware, Social engineering, and Phishing are some of the common types of cyber-attacks. Cyber I can help organizations and individuals protect their systems and data from unauthorized access.",
    servicesIncluded: [
      {
        _id: 101,
        title: "Cyber Security Consulting",
      },
      {
        _id: 102,
        title: "Network Testing",
      },
      {
        _id: 103,
        title: "Detecting malicious threat",
      },
      {
        _id: 104,
        title: "Ethical Hacking",
      },
    ],
  },
  {
    _id: "1004",
    icon: <SiAntdesign />,
    title: "Website Design",
    des: "The web isn't about moving images, but about images that move you. So it's surprising how many businesses get tricked into focusing solely on the technical side of digital marketing.",
    imgSrc: educareImg,
    website: "https://educare.reactbd.com/",
    servicesDes:
      "In this day and age, the Internet is the place to be for networking, brand awareness, selling, promoting, recruiting and so much more. And it all begins with your website. Want people to know about your brand? People from all over the globe will start their search by locating your website. Get your webpage professionally designed by a leading Singapore web design company.",
    servicesOffer:
      "To design a modern and robust website you can always count on me.",
    servicesIncluded: [
      {
        _id: 101,
        title: "Online Store",
      },
      {
        _id: 102,
        title: "Portfolio",
      },
      {
        _id: 103,
        title: "Blog",
      },
      {
        _id: 104,
        title: "Restaurants",
      },
    ],
    servicesCategories: [
      {
        _id: 201,
        title: "Logo Design",
      },
      {
        _id: 202,
        title: "Brand Design",
      },
      {
        _id: 203,
        title: "Multiple Webpage",
      },
      {
        _id: 204,
        title: "Responsive Design",
      },
    ],
  },
  {
    _id: "1005",
    icon: <CgIfDesign />,
    title: "UI/UX Design",
    des: "Speed up your product development process with revolutionary Merge technology. From UI designing to UI developing – create consistent interfaces using the same building blocks with me.",
    imgSrc: saharaImg,
    website: "https://unknown2832021.github.io/Sahara_New_Beginning/",
    servicesDes:
      "Design at scale with dynamic and reusable design systems – your centralized place with interactive UI components and documentation. Share it easily with your team and ensure consistency across the whole company. I can create that field productively to help you out with your interactive design.",
    servicesIncluded: [
      {
        _id: 101,
        title: "Responsive Design",
      },
      {
        _id: 102,
        title: "Wireframing",
      },
      {
        _id: 103,
        title: "SiteMap",
      },
      {
        _id: 104,
        title: "Style Guide",
      },
      {
        _id: 105,
        title: "User testing",
      },
    ],
    servicesCategories: [
      {
        _id: 201,
        title: "Faster Prototyping",
      },
      {
        _id: 202,
        title: "Interactive Previews",
      },
      {
        _id: 203,
        title: "Access Anywhere",
      },
      {
        _id: 204,
        title: "Test On Mobile",
      },
      {
        _id: 205,
        title: "High and Low Fidelity",
      },
    ],
  },
  {
    _id: "1006",
    icon: <FaGlobeAmericas />,
    title: "SEO / Web Hosting",
    des: "With a deep understanding of the latest algorithms and technologies, I provide top-notch services to help businesses and individuals increase their online visibility and improve their web presence.",
    imgSrc: cyberBlogImg,
    website: "https://personalview.vercel.app/",
    servicesDes:
      "By using the SEO and web hosting services, your website will have a stronger online presence, improved search engine ranking, and faster loading speed. This can lead to increased traffic, higher conversions, and ultimately, growth for your business. Our hosting solutions ensure reliable uptime and support, giving you peace of mind. With our expertise in SEO, we'll help you target the right keywords, optimize your website's content, and improve its overall visibility, giving you a competitive edge in your industry. Choose our services to improve your website's performance and take your business to the next level.",
    servicesIncluded: [
      {
        _id: 101,
        title: "Responsive Design",
      },
      {
        _id: 102,
        title: "Coding",
      },
      {
        _id: 103,
        title: "Hostings",
      },
      {
        _id: 104,
        title: "SEO Optimization",
      },
    ],
  },
];
// ======================== Services Info End here ========================
